export default __webpack_public_path__ + "static/media/Avatar.5b9f074f.svg";